import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { Alert } from "antd"
import fileDownload from "js-file-download"

import { FileService, NotificationService } from "Shared/services"
import { useHistory } from "react-router-dom"
import useStateIfMounted from "Shared/utils/hooks/useStateIfMounted"

const FileDownloadUrl: React.FC<{}> = () => {
    const { t } = useTranslation()
    const history = useHistory()
    const [download, setDownload] = useStateIfMounted<{ url: string; fileName: string } | undefined>(undefined)

    useEffect(() => {
        let searchParams = new URLSearchParams(window.location.search)
        const urlParamBase64 = searchParams.get("url")
        if (!urlParamBase64) {
            history.push("/dashboard")
            return
        }
        const urlParam = Buffer.from(urlParamBase64, "base64").toString()
        const pathname = new URL(urlParam).pathname
        const index = pathname.lastIndexOf("/")
        const fileName = pathname.substring(index + 1)
        setDownload({ url: urlParam, fileName })
    }, [])

    useEffect(() => {
        if (!download) return
        FileService.getSignedUrl(download.url)
            .then(({ data: { signedUrl } }) => window.open(signedUrl, "_self"))
            .catch((err) => NotificationService.showErrorNotificationBasedOnResponseError(err, t("error:file.download.title"), t("error:file.download.message")))
    }, [download])

    if (!download) return <></>

    return (
        <div className="mx-10 md:mx-0">
            <Alert message={<span className="font-bold">{t("label:file_download", { fileName: download.fileName })}</span>} type="info" showIcon={true} />
        </div>
    )
}

export default FileDownloadUrl
